import { render, staticRenderFns } from "./EndorsementReview.vue?vue&type=template&id=f669da88&scoped=true"
import script from "./EndorsementReview.vue?vue&type=script&lang=js"
export * from "./EndorsementReview.vue?vue&type=script&lang=js"
import style0 from "./EndorsementReview.vue?vue&type=style&index=0&id=f669da88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f669da88",
  null
  
)

export default component.exports